import React from "react";
import Form from "react-bootstrap/Form";

const PersonalDetails = ({ onChange, values }) => {
  return (
    <>
      <h3 className="subTitle">פרטים אישיים</h3>
      <Form.Group className="mb-3" controlId="formBasicName">
        <Form.Label className="fw-semibold mb-2">שם</Form.Label>
        <Form.Control
          required
          type="text"
          value={values?.firstName}
          name="firstName"
          placeholder="השם שלי"
          onChange={(e) => onChange({ [e.target.name]: e.target.value })}
        />
        <Form.Control.Feedback type="invalid">
          נא להכניס שם
        </Form.Control.Feedback>
      </Form.Group>
      {/* <div className="invalid-feedback">
        This is an error state form validation message!
      </div> */}

      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label className="fw-semibold mb-2">אימייל</Form.Label>
        <Form.Control
          required
          type="email"
          value={values?.email}
          name="email"
          placeholder="האימייל שלי"
          onChange={(e) => onChange({ [e.target.name]: e.target.value })}
        />
        <Form.Control.Feedback type="invalid">
          נא להכניס אימייל תקין
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicPhone">
        <Form.Label className="fw-semibold mb-2">טלפון</Form.Label>
        <Form.Control
          required
          type="tel"
          value={values?.phone}
          name="phone"
          placeholder="הטלפון שלי"
          onChange={(e) => onChange({ [e.target.name]: e.target.value })}
        />
        <Form.Control.Feedback type="invalid">
          נא להכניס טלפון
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
};

export default PersonalDetails;
